import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { addAlert, selectLoading } from "src/modules/notification/redux";
import { unwrapResult } from "@reduxjs/toolkit";
import adminRolesApi from "src/configs/apis/admin-roles";
import adminApi from "src/configs/apis/admins";
import { useAdminContext } from "../../../contexts/admin.context";
import AdminRoleDialog from "./admin-role-dialog.component";

export default function AdminRoleDialogContainer({ onSuccess }) {
  const {
    adminRoles,
    adminRoleOpen,
    setAdminRoleOpen,
    isError,
    isLoading,
    isUpdating,
    selectedAdmin,
    selectedAdminRole,
  } = useAdminContext();

  const dispatch = useDispatch();
  const onAdminRoleDialogCloseClick = () => {
    setAdminRoleOpen(false);
  };

  const handleSubmit = async (values) => {
    await adminApi.updateAdminRole({
      uuid: selectedAdmin.uuid,
      adminRoleUuid: values.adminRole.uuid,
    }).then(unwrapResult)
    .then(() => {
      dispatch(
        addAlert({
          severity: "success",
          message: "Admin role updated successfully",
        })
      );
      if (onSuccess) {
        onSuccess();
      }
    }).finally(() => {
      setAdminRoleOpen(false);
    });
  };

  return (
    <AdminRoleDialog
      open={adminRoleOpen}
      isError={isError}
      handleSubmit={handleSubmit}
      onAdminRoleDialogCloseClick={onAdminRoleDialogCloseClick}
      isLoading={isLoading}
      isUpdating={isUpdating}
    />
  );
}
